<template>
  <v-main class="pa-7 pt-0">
    <h1 v-if="!$route.meta.subTitle">{{$route.name == "Activity log user" || $route.name == "Activity log teacher" ? usernameLog + $t($route.meta.title) : $t($route.meta.title)}}</h1>
    <h1 v-else>{{$t($route.meta.subTitle)}}</h1>
    <slot />
  </v-main>
</template>

<script>
export default {
  store: ['usernameLog'],
  name: "MainView"
};
</script>
